import React, { useState } from "react";
import { ChevronDownIcon } from "@heroicons/react/24/solid";

const trainingProgramsData = [
  {
    id: 1,
    theme: "Руководители дошкольных организаций",
    name: "«Совершенствование профессиональных и управленческих компетенций руководителей по повышению эффективности воспитательно-образовательного и управленческого процесса дошкольного образования»",
    goal: "Развитие стратегического управления и совершенствование профессиональных компетенций руководителей в сфере дошкольного образования. ",
    modules: [
      "1.\tНормативные правовые и психолого-педагогические аспекты дошкольного образования;",
      "2.\tСовременный менеджмент в дошкольном образовании;",
      "3.\tВзаимодействие участников воспитательно-образовательного процесса.",
    ],
    objectives: [
      "- знают приоритетные направления системы дошкольного воспитания и обучения, утвержденные нормативными правовыми актами",
      "- применяют инструменты оценки эффективности деятельности для повышения качества образовательной среды",
      "- знают менеджмент качества дошкольной организации",
      "- знают о лучших отечественных и международных практиках управления дошкольной организацией образования",
      "- владеют практическими навыками управления дошкольной организацией в условиях инклюзивного образования",
      "- воспитывают и обучают на основе общечеловеческих и национальных ценностей, в тесном взаимодействии детского сада с родителями",
    ],
  },
  {
    id: 2,
    theme: "Методисты дошкольных организаций",
    name: "«Развитие менторских и профессиональных компетенций по повышению эффективности воспитательно-образовательного процесса дошкольного образования»",
    goal: "формирование профессиональных навыков и менторских компетенций методиста дошкольных организаций для конструирования предметно-развивающей среды, оптимально адаптированной для успешного обучения и развития детей.",
    modules: [
      "1. Нормативные правовые акты дошкольного образования;",
      "2. Организация предметно-развивающей среды дошкольного образования;",
      "3. Взаимодействие участников воспитательно-образовательного процесса.",
    ],
    objectives: [
      "- знают современные формы организации методического обеспечения деятельности и оказания помощи педагогам в реализации типовой учебной программы дошкольного воспитания и обучения;",
      "- знают лучшие практики менторинга и их применимость в дошкольном образовании;",
      "- владеют навыками менторства;",
      "- умеют создавать образовательную среду для обмена опытом и знаниями между педагогами;",
      "- владеют практическими навыками методической поддержки в условиях инклюзивного образования;",
      "- воспитывают и обучают детей на основе общечеловеческих и национальных ценностей в тесном взаимодействии детского сада с родителями;",
      "- владеют навыками проектирования и моделирования воспитательно-образовательного процесса с применением цифровых инструментов.",
    ],
  },
  {
    id: 3,
    theme: "Воспитатели дошкольных организаций",
    name: "«Совершенствование профессиональных компетенций воспитателей дошкольного образования с применением цифровых технологий»",
    goal: "совершенствование профессиональных и цифровых компетенций воспитателей по организации предметно-развивающей среды и использованию инновационных технологий в воспитательно-образовательном процессе в дошкольных организациях.",
    modules: [
      "1. Нормативные правовые акты дошкольного образования;",
      "2. Организация предметно-пространственной развивающей среды;",
      "3. Организация работы по взаимодействию с родителями.",
    ],
    objectives: [
      "- создают предметно-развивающую среду с применением цифровых инструментов;",
      "- владеют практическими навыками работы с инновационными онлайн-платформами для дошкольного образования с использованием искусственного интеллекта;",
      "- владеют инструментом самооценки и повышения качества образовательной среды в детских садах;",
      "- умеют организовывать современные формы работы с родителями;",
      "- владеют практическими навыками организации воспитательно-образовательного процесса для детей с особыми образовательными потребностями.",
    ],
  },
  {
    id: 4,
    theme: "Специальные педагоги дошкольных организаций",
    name: "«Повышение профессионального мастерства специальных педагогов по взаимодействию с детьми дошкольного образования»",
    goal: "совершенствование профессиональных компетенций специальных педагогов дошкольных организаций по внедрению инновационных подходов в коррекционном, индивидуализированном обучении детей с особыми образовательными потребностями (далее - ООП).",
    modules: [
      "1. Нормативные правовые акты дошкольного образования;",
      "2. Содержательные и методические особенности программы;",
      "3. Организация работы по взаимодействию с родителями.",
    ],
    objectives: [
      "- знают основные нормативные правовые акты в сфере дошкольного образования, также в условиях инклюзивного образования;",
      "- владеют современными методами коррекционной работы в дошкольных организациях образования для разных категорий детей, в том числе и для детей с ООП;",
      "- знают технологии и формы работы при нарушениях эмоционально-волевой сферы у детей дошкольного возраста;",
      "- владеют практическими навыками разработки и реализации коррекционно-развивающих программ;",
      "- умеют воспитывать и обучать на основе общечеловеческих и национальных ценностей в сотрудничестве с родителями;",
      "- владеют навыками обучения родителей специальным приёмам воспитания детей.",
    ],
  },
  {
    id: 5,
    theme: "Педагоги-психологи дошкольных организаций",
    name: "«Профессиональное развитие педагогов-психологов в области \nпсихолого-педагогического сопровождения воспитательно-образовательного процесса в дошкольных организациях»",
    goal: "совершенствование профессиональных компетенций педагогов-психологов в области проектирования и психолого-педагогического сопровождения воспитательно-образовательного процесса в дошкольных организациях.",
    modules: [
      "1. Нормативные правовые акты дошкольного образования;",
      "2. Психолого-педагогическое сопровождение воспитательно; образовательного процесса в дошкольных организациях;",
      "3. Организация работы по взаимодействию с родителями.",
    ],
    objectives: [
      "- владеют навыками применения нормативных правовых актов Республики Казахстан дошкольного образования при создании специальных условий и психолого-педагогического сопровождения детей с особыми образовательными потребностями;",
      "- владеют методиками разработки индивидуализированных планов сопровождения детей с особыми образовательными потребностями;",
      "- владеют знаниями о ключевых факторах развития эмоционального интеллекта;",
      "- знают современные методы коррекционной работы в дошкольных организациях образования для разных категорий детей, в том числе и для детей с ООП;",
      "- владеют навыками воспитания и обучения на основе общечеловеческих и национальных ценностей в тесном взаимодействии детского сада с родителями;",
      "- владеют навыками проектирования воспитательно-образовательного процесса с применением цифровых инструментов, имеют доступ к обучающим ресурсам.",
    ],
  },
];

const AccordionItem = ({ program, isOpen, onToggle }) => {
  return (
    <div className="border-b border-gray-600 last:border-b-0">
      <button
        type="button"
        className="flex justify-between items-center w-full py-4 px-5 text-left text-white hover:bg-gray-700/50 focus:outline-none focus-visible:ring focus-visible:ring-blue-400 focus-visible:ring-opacity-75 transition-colors duration-200"
        onClick={onToggle}
        aria-expanded={isOpen}
        aria-controls={`content-${program.id}`}
      >
        <h3 className="text-lg md:text-xl font-semibold">{program.theme}</h3>
        <ChevronDownIcon
          className={`w-6 h-6 text-blue-300 transform transition-transform duration-300 ${
            isOpen ? "rotate-180" : ""
          }`}
          aria-hidden="true"
        />
      </button>

      <div
        id={`content-${program.id}`}
        className={`overflow-hidden transition-all duration-300 ease-in-out ${
          isOpen ? "max-h-[2500px] opacity-100" : "max-h-0 opacity-0"
        }`}
        role="region"
        aria-labelledby={`button-${program.id}`}
      >
        <div className="py-5 px-5 lg:px-8 space-y-5">
          <div>
            <p className="font-bold text-gray-100 mb-1 underline underline-offset-2">
              Название ОП:
            </p>
            <p className="text-gray-200 text-sm">{program.name}</p>
          </div>
          <div>
            <p className="font-bold text-gray-100 mb-1 underline underline-offset-2">
              Цель:
            </p>
            <p className="text-gray-200 text-sm">{program.goal}</p>
          </div>
          {program.modules && program.modules.length > 0 && (
            <div>
              <p className="font-bold text-gray-100 mb-2 underline underline-offset-2">
                Модули:
              </p>
              <ul className="space-y-2 list-none pl-0">
                {program.modules.map((module, index) => (
                  <li key={index} className="flex items-start space-x-3">
                    <span className="text-gray-200 text-sm">{module}</span>
                  </li>
                ))}
              </ul>
            </div>
          )}
          {program.objectives && program.objectives.length > 0 && (
            <div>
              <p className="font-bold text-gray-100 mb-2 underline underline-offset-2">
                Ожидаемые результаты:
              </p>
              <ul className="space-y-2 list-none pl-0">
                {program.objectives.map((objective, index) => (
                  <li key={index} className="flex items-start space-x-3">
                    <span className="text-gray-200 text-sm">{objective}</span>
                  </li>
                ))}
              </ul>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

const TrainingProgramsAccordion = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const handleToggle = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section id="coursesList" className="py-12 md:py-16 bg-[#01333E] font-montserrat">
      <div className="container mx-auto px-4 max-w-4xl">
        <h2 className="text-3xl md:text-4xl font-bold text-center text-white mb-8 md:mb-12">
          Программы обучения
        </h2>
        <div className="bg-[#0a2a33] rounded-lg shadow-lg overflow-hidden">
          {trainingProgramsData.map((program, index) => (
            <AccordionItem
              key={program.id}
              program={program}
              isOpen={openIndex === index}
              onToggle={() => handleToggle(index)}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default TrainingProgramsAccordion;
